import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Container,
  Typography,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const products = [
  {
    id: 'verabind-tau',
    name: 'VeraBIND Tau',
    description:
      'VeraBIND™ Tau is a first-in-class, blood-based assay that quantifies disease-driving hyperphosphorylated tau activity, giving clinicians an affordable, non-invasive tool for the early detection and diagnosis of Alzheimer\'s disease; verified against tau-PET imaging with over 96% overall agreement for confidence you can trust.',
    image: '/kit_0001.png',
    imageAlt: 'VeraBIND Tau kit',
  },
];

export default function CustomerLanding() {
  return (
    <Container disableGutters sx={{ mt: 2 }}>
      <Box
        sx={{
          maxWidth: 'md',
          mx: 'auto',
          textAlign: 'left',
          pt: { xs: 2, md: 3 },
          pb: { xs: 1, md: 1.5 },
        }}
      >
        <Box sx={{ mb: 3 }}>
          <Typography variant="h4" component="h1">
            Available Products
          </Typography>
          <Typography variant="body1" sx={{ mt: 1 }}>
            Browse available kits and continue to purchase when you are ready.
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr',
            gap: 3,
          }}
        >
          {products.map((product) => (
            <Card
              key={product.id}
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                alignItems: 'stretch',
                border: '1px solid #97999B',
                boxShadow: 'none',
              }}
            >
              <CardMedia
                component="img"
                image={product.image}
                alt={product.imageAlt}
                sx={{
                  width: { xs: '100%', sm: 220 },
                  height: { xs: 180, sm: '100%' },
                  objectFit: 'cover',
                  borderRight: { xs: 'none', sm: '1px solid #97999B' },
                  borderBottom: { xs: '1px solid #97999B', sm: 'none' },
                }}
              />
              <CardContent
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  flexGrow: 1,
                  gap: 2,
                }}
              >
                <Box>
                  <Typography variant="h5" component="h2" gutterBottom>
                    {product.name}
                  </Typography>
                  <Typography variant="body1">{product.description}</Typography>
                </Box>
                <Box>
                <Button
                  variant="contained"
                  color="primary"
                  component={RouterLink}
                  to="/mock/customer-purchase"
                  sx={{
                    fontWeight: 700,
                    letterSpacing: '0.02em',
                    boxShadow: '0 12px 22px rgba(0, 118, 127, 0.28)',
                    py: 1.1,
                  }}
                >
                  Continue to Purchase
                </Button>
                </Box>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Box>
    </Container>
  );
}
